export default {"src":"/_next/static/media/customer-spotify.539eeb5a.svg","height":2931,"width":9772};